import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { DataProvider } from "./DataContext";
import { canAccess }   from "./auth";

import Login           from "./pages/Login";
import Dashboard       from "./pages/Dashboard";
import AttackAnalytics from "./pages/AttackAnalytics";
import CyberAlerts     from "./pages/CyberAlerts";
import Reports         from "./pages/Reports";
import ThreatIntel            from "./pages/ThreatIntel";
import ComplianceGapAnalysis  from "./pages/ComplianceGapAnalysis";
import UserManagement  from "./pages/UserManagement";

function PrivateRoute({ children, path }) {
  const raw = sessionStorage.getItem("nexgen_user");
  if (!raw) return <Navigate to="/login" replace />;

  const user = JSON.parse(raw);

  // Check session expiry (8 hours)
  const loginAt = new Date(user.loginAt);
  const now     = new Date();
  if ((now - loginAt) > 8 * 60 * 60 * 1000) {
    sessionStorage.removeItem("nexgen_user");
    return <Navigate to="/login" replace />;
  }

  // Role-based access check
  if (path && !canAccess(user.role, path)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default function App() {
  return (
    <DataProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/"          element={<PrivateRoute path="/"><Dashboard /></PrivateRoute>} />
          <Route path="/analytics" element={<PrivateRoute path="/analytics"><AttackAnalytics /></PrivateRoute>} />
          <Route path="/alerts"    element={<PrivateRoute path="/alerts"><CyberAlerts /></PrivateRoute>} />
          <Route path="/reports"   element={<PrivateRoute path="/reports"><Reports /></PrivateRoute>} />
          <Route path="/intel"     element={<PrivateRoute path="/intel"><ThreatIntel /></PrivateRoute>} />
          <Route path="/compliance" element={<PrivateRoute path="/compliance"><ComplianceGapAnalysis /></PrivateRoute>} />
          <Route path="/users"     element={<PrivateRoute path="/users"><UserManagement /></PrivateRoute>} />
          <Route path="*"          element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </DataProvider>
  );
}
